export default "__VITE_ASSET__d82cca25__"